import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as cartPreviewActions from "../actions/cartPreviewActions";
import TestLeftPage from "../pages/products/TestLeftPage.jsx";

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(cartPreviewActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TestLeftPage);
